module.exports = __webpack_public_path__ + "img/A-2137877-1417968489-5854.jpeg.c146cbe5.jpg";